import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'E-mailberichten',
  labels: {
    view_full_message: 'Volledig bericht bekijken',
    status: 'Status:',
    on: 'Aan',
    off: 'Uit',
  },
  tiles: {
    sends_count: 'Berichten verzonden',
    delivery_rate: 'Afleverpercentage',
    delivered_suffix: 'afgeleverd',
    open_rate: 'Openingspercentage',
    opened_suffix: 'geopend',
    click_rate: 'Klikpercentage',
    clicked_suffix: 'geklikt',
    spam_report_rate: 'Spamklachtpercentage',
    spam_reports_suffix: 'meldingen',
    unsubscribe_rate: 'Uitschrijfpercentage',
    unsubscribes_suffix: 'uitschrijvingen',
  },
  toasts: {
    failed_to_update_status: 'Status bijwerken mislukt',
    failed_to_load_data: 'Gegevens laden mislukt',
  },

  preview_modal: {
    title: 'Sjabloonvoorbeeld',
    labels: {
      subject: 'Onderwerp:',
      close: 'Sluiten',
    },
    toasts: {
      failed_to_load_data: 'Voorbeeldgegevens laden mislukt',
    },
    template_data: {
      recipient_name: '&lt;Voornaam&gt;',
    },
  },
};
